// extracted by mini-css-extract-plugin
export default {"Boxes":"Boxes_Boxes__BH2s6"};